import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { AngularMaterialsModules } from '../../../module/materials.module'
import { AgentContentType, AgentCreatedContent } from '../models/agent.models'

interface ContentSection {
  type: AgentContentType
  label: string
  icon: string
  items: AgentCreatedContent[]
}

@Component({
  selector: 'ddc-agent-content',
  templateUrl: './ddc-agent-content.component.html',
  styleUrls: ['./ddc-agent-content.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialsModules],
})
export class DdcAgentContentComponent {
  @Input() theme: string = 'light-theme'

  sections: ContentSection[] = []

  @Input() set contents(value: AgentCreatedContent[]) {
    const defs: { type: AgentContentType; label: string; icon: string }[] = [
      { type: AgentContentType.DICTIONARY, label: 'Dictionaries', icon: 'menu_book' },
      { type: AgentContentType.NOTE, label: 'Notes', icon: 'description' },
      { type: AgentContentType.QUIZ, label: 'Quizzes', icon: 'quiz' },
      { type: AgentContentType.FIGURE, label: 'Figures', icon: 'image' },
    ]
    this.sections = defs.map(d => ({
      ...d,
      items: (value ?? []).filter(c => c.type === d.type),
    }))
  }
}
